import React from 'react';
import StockTransactionModule from '../transaction/components/StockTransactionModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryStockTransactionModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.stocktransaction', action: 'read' },
        { resource: 'inventory.item', action: 'read' },
      ]}
    >
      <StockTransactionModule />
    </InventoryPermissionGuard>
  );
}
